import React from 'react';
import '../css/Resume.css';
import download from '../img/download.png';
import pdf from '../img/CV.pdf';

function Resume() {
    return (
        <div className="resume">
            <a  href={pdf} target="_blank">
                <img src={download} alt="" />
                <h1>View my full resume</h1>
            </a>

        </div>
    )
}

export default Resume
